import { useLayoutEffect } from "react";
import Home from "./Home";
import ArabicHome from "./ArabicHome";
import "./HomeOptionTwo.css";

export default function HomeOptionTwo({ language = "en" }) {
  const isArabic = language === "ar";

  useLayoutEffect(() => {
    document.documentElement.classList.add("logo-theme-preview");

    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "/css/home-option-two-fonts.css?v=2";
    fontLink.dataset.logoThemeFonts = "true";

    const themeLink = document.createElement("link");
    themeLink.rel = "stylesheet";
    themeLink.href = "/css/custom-logo-theme.css?v=5";
    themeLink.dataset.logoTheme = "true";

    const typographyLink = document.createElement("link");
    typographyLink.rel = "stylesheet";
    typographyLink.href = "/css/home-option-two-typography.css?v=3";
    typographyLink.dataset.logoThemeTypography = "true";

    document.head.append(fontLink, themeLink, typographyLink);

    return () => {
      document.documentElement.classList.remove("logo-theme-preview");
      fontLink.remove();
      themeLink.remove();
      typographyLink.remove();
    };
  }, []);

  return isArabic ? <ArabicHome optionTwo /> : <Home optionTwo />;
}




